import Support from "../components/support/Support";
import { AppLayout } from "../layout/AppLayout";

function Help() {
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10 pb-7 px-5 min-h-screen flex flex-col">
        <Support />
      </div>
    </AppLayout>
  );
}

export default Help;
